Core.SubContractorsRouter = Core.SubRouter.extend({
    routes: {
        '': 'subcontractor',
        'new': 'createSubContractor',
        ':id': 'viewSubContractor',
        ':id/edit': 'editSubContractor',
    },

    subcontractor: function() {
        if (!Core.client.hasFeature('self_invoicing') || !Core.client.hasPermissionInAnyGroup('view_subcontractors')) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        app.setMainView(new SubContractorListView({scrolling: true}), 'directory');
    },

    createSubContractor: function() {
        var canCreate = Core.client.groups.some(function(group) {
            return Core.client.groupHasFeature(group.id, 'self_invoicing') &&
                   Core.client.hasGroupPermission(group.id, 'admin_subcontractors');
        });
        if (!canCreate) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        app.setMainView(new SubContractorDetailsView({editing: true}), 'directory');
    },

    viewSubContractor: function(id) {
        if (!Core.client.hasFeature('self_invoicing') || !Core.client.hasPermissionInAnyGroup('view_subcontractors')) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        app.setMainView(new SubContractorDetailsView({id: id}), 'directory');
    },

    editSubContractor: function(id) {
        if (!Core.client.hasFeature('self_invoicing') || !Core.client.hasPermissionInAnyGroup('admin_subcontractors')) {
            app.setMainView(new DashboardView(), 'dashboard');
            return;
        }
        app.setMainView(new SubContractorDetailsView({id: id, editing: true}), 'directory');
    },
});
